export const getChartPieData = productData => {
  if (productData?.assets) {
    return productData.assets?.map(it => ({
      name: it.assetName,
      y: it.investmentPercent,
    }));
  }

  if (productData?.Structure) {
    return productData?.Structure.map(it => ({
      name: it.ticker,
      y: Math.round(it.weight * 1000) / 10,
    }));
  }

  return [];
};
